/**
 * Handoff Matching-Board → PB-Profil: "BK fürs Matching ausgewählt".
 *
 * Das Board wählt PB + BK, navigiert ins PB-Profil und hinterlegt hier die
 * BK-Vorauswahl. Das PB-Dashboard konsumiert den Eintrag beim Mount und
 * öffnet den Drawer "Neue Betreuung anlegen" mit der BK vorausgewählt.
 * sessionStorage: übersteht die Navigation, aber keinen Tab-Wechsel-Spam;
 * konsumiert = gelöscht (einmalig).
 */
const KEY = 'sh24.care_create_handoff';

export interface CareCreateHandoff {
  /** PB (User-ID), in dessen Profil der Drawer geöffnet werden soll. */
  pbUserId: number;
  /** Vorausgewählte Betreuungskraft (User-ID). */
  bkUserId: number;
}

export function setCareCreateHandoff(data: CareCreateHandoff): void {
  try { sessionStorage.setItem(KEY, JSON.stringify(data)); } catch { /* private mode */ }
}

/** Liest + löscht den Handoff — nur wenn er zum geöffneten PB gehört. */
export function consumeCareCreateHandoff(pbUserId: number): CareCreateHandoff | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const data = JSON.parse(raw) as CareCreateHandoff;
    if (Number(data.pbUserId) !== pbUserId) return null;
    sessionStorage.removeItem(KEY);
    return data;
  } catch {
    return null;
  }
}
